import React from 'react';
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-responsive-modal';
import { setPopup } from '../../../redux/messageSlice';
import { DELETE_FILE_MUTATION } from '../../../apollo/Mutations';
import { useMutation } from '@apollo/client';
import toast from 'react-hot-toast'

const DeleteFile = () => {
    const dispatch = useDispatch()
    const { delete_file, active_file } = useSelector(state => state.message);

    const [deleteFile] = useMutation(DELETE_FILE_MUTATION)
    const handleDelete = () => {
        try {
            // debugger;
            deleteFile({
                variables: {
                    input: {
                        file_id: active_file?.id,
                        participants: active_file?.participants,
                    }
                }
            })
            toast.success('File deleted!');
            dispatch(setPopup({ key: 'delete_file', value: false }))
            // closePopUp();
            // if (setallFiles) setallFiles([...allFiles.filter(f => f.id !== data.id)])
        } catch (error) {
            console.log("🚀 ~ WarningPopup ~ error:", error)
        }
    }

    return (
        <Modal
            open={delete_file}
            onClose={() => dispatch(setPopup({ key: 'delete_file', value: false }))}
            center
            closeIcon={<MdClose className="text-3xl mt-1 text-teal-600 dark:text-white " />}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay',
                modal: 'customModal',
            }}
        >
            <div className="flex items-center justify-center">
                <div className="">
                    <h2 className="text-xl font-semibold text-teal-600">Delete file</h2>
                    <p className="mt-2 text-teal-600">
                        Are you sure you want to delete this file? This cannot be
                        <span className="text-text-body dark:text-teal-400"> undone.</span>
                    </p>
                    <div className="mt-4 flex flex-col gap-2.5">
                        <button className="px-4 py-2.5 bg-red-600 text-white rounded-md" onClick={handleDelete}> Delete </button>
                        <button onClick={() => dispatch(setPopup({ key: 'delete_file', value: false }))} className="px-4 py-2.5 bg-teal-600 text-white rounded-md"> Cancel </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteFile;